'use client'

import { createContext, useContext } from 'react'
import * as styles from './Menu.css'
import type { ButtonProps } from '@shared/components/Button/Button'
import * as AriakitMenu from '@ariakit/react/menu'
import Button from '@shared/components/Button/Button'
import { Stack } from '@christiankaindl/lyts'

/**
 * `selection` lists (checkbox / radio items) put the control on the left and
 * item icons on the right, so the two never share a column; `action` lists
 * keep icons on the left.
 */
export type MenuLayout = 'action' | 'selection'

const MenuLayoutContext = createContext<MenuLayout>('action')

export function useMenuLayout(): MenuLayout {
  return useContext(MenuLayoutContext)
}

export function Menu({
  children,
  unmountOnHide = true,
  layout = 'action',
  ...props
}: AriakitMenu.MenuProps & { layout?: MenuLayout }) {
  return (
    <AriakitMenu.Menu
      unmountOnHide={unmountOnHide}
      portal
      gutter={6}
      {...props}
      render={<Stack gap='1px' />}
      className={`${styles.content}${layout === 'selection' ? ` ${styles.selectionContent}` : ''}`}
    >
      <MenuLayoutContext.Provider value={layout}>
        {children}
      </MenuLayoutContext.Provider>
    </AriakitMenu.Menu>
  )
}

export function MenuButton({
  children,
  ...props
}: AriakitMenu.MenuButtonProps & ButtonProps) {
  return (
    <AriakitMenu.MenuButton
      render={<Button variant={props.variant ?? 'flat'} />}
      className={`${styles.trigger} ${props.className ?? ''}`}
      {...props}
    >
      {children}
    </AriakitMenu.MenuButton>
  )
}

export function MenuProvider(props: AriakitMenu.MenuProviderProps) {
  return <AriakitMenu.MenuProvider {...props} />
}

export default MenuProvider
